import { Location } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-back-link',
    templateUrl: './back-link.component.html',
    styleUrls: ['./back-link.component.scss'],
    standalone: false
})
export class BackLinkComponent {
  @Input('routerLinkpath') routerLinkPath: string[];
  @Input('text') text: string;
  @Input('icon') icon: string;
  @Input('goBack') goBack: boolean;

  constructor(private router: Router, private location: Location) {

  }

  /**
   * Function to handle the click of the button.  
   * It will go back if goBack is set to true, 
   * otherwise it will navigate to the provided routerLinkpath
   * or /type-study if none  is provided
   */
  public clicked(): void {
    if (this.goBack) {
      this.location.back();
    } else {
      this.router.navigate(this.routerLinkPath || ['/type-study']);
    }
  }
}
